import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import ProductDetail from '../components/product-detail'

const ProductPage = ({pageContext}) => {
  const {
    lang,
    productData,
    allProducts,
    sitePrefix,
  } = pageContext

  return (
    <Layout { ...pageContext } >
      <SEO title="Duro" lang={lang} />
      <ProductDetail {...productData} allProducts={allProducts} sitePrefix={sitePrefix} />
    </Layout>
  )
}

export default ProductPage
